import React, { useEffect, useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';


function CircularProgressBar(props) {
  const [percentage, setPercentage] = useState(0);
  const Level=props.level
  useEffect(() => {
    setTimeout(() => {
      if (percentage < Level) {
        setPercentage(percentage + 1);
      }
    }, 50);
  }, [percentage]);

  
  const progressColor = props.color; // Replace with the desired color

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ width: 150, color: progressColor, stroke: progressColor }}>
        <CircularProgressbar
          value={percentage}
          text={`${percentage}%`}
          styles={buildStyles({
            pathColor: progressColor,
            textColor: progressColor,
            trailColor: '#e0e0e0b3',
          })}
        />
        <h4 style={{marginTop: '20px'}}>{props.skill}</h4>
      </div>
    </div>
  );
}

export default CircularProgressBar;
